import React, { FC } from "react";

import CloseIcon from "@mui/icons-material/Close";

import { StyledSelectedFilterOption } from "./styled";

type SelectedFilterProps = {
    filterId: number | string;
    label: string;
    onRemove: () => void;
    showRemoveIcon: boolean;
};

const SelectedFilter: FC<SelectedFilterProps> = ({ filterId, label, onRemove, showRemoveIcon = false }) => {
    return (
        <StyledSelectedFilterOption
            data-testid={`filter_dropdown-select-option_${filterId}`}
            endIcon={
                showRemoveIcon && (
                    <CloseIcon
                        color="secondary"
                        onClick={onRemove}
                        data-testid={`filter_dropdown-remove-option_${filterId}`}
                    />
                )
            }
        >
            {label}
        </StyledSelectedFilterOption>
    );
};

export default SelectedFilter;
